import { array, boolean, object, optional, string } from 'zod';

export const CHOICE_TEXT_REQUIRED_MESSAGE = 'Choice text is required';
export const CHOICE_CONTENT_REQUIRED_MESSAGE =
  'Choice text or image is required';

export const hasChoiceContent = (choice: {
  text?: string;
  imageUrl?: string;
}) => !!choice.text || !!choice.imageUrl;

export const QuizMultipleDataSchema = object({
  choiceList: array(
    object({
      key: string(),
      text: optional(string()),
      richText: optional(string()),
      imageUrl: optional(string()),
      isAnswer: boolean(),
    }).refine(hasChoiceContent, {
      message: CHOICE_CONTENT_REQUIRED_MESSAGE,
      path: ['text'],
    }),
  ).refine(
    data => {
      return data.some(choice => choice.isAnswer);
    },
    {
      message: 'At least one choice must be an answer',
      path: ['choiceList'],
    },
  ),
});
